import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Users, Building2, Package, Home,Warehouse,Building,UserCheck   } from "lucide-react";

interface TopSummaryCardsProps {
  summaryData: any;  // or your exact type
  baseRoute?: string;
}

const TopSummaryCards: React.FC<TopSummaryCardsProps> = ({
  summaryData,
  baseRoute = "/signage",
}) => {
  const navigate = useNavigate();
  const data = summaryData || {};

  // 🔹 Memoize the cards array so it only recalculates when data changes
  const cards = useMemo(() => {
    return [
      {
        title: "Total Brokerages",
        value: Number(data?.total_brokerages || 0).toLocaleString(),
        icon: <Building2 size={20} />,
        bg: "#dbeafe",
        color: "#155dfc",
        href: `${baseRoute}/brokerageFirms`,
      },
      {
        title: "Total Agents",
        value: Number(data?.total_agents || 0).toLocaleString(),
        icon: <Users size={20} />,
        bg: "#dcfce7",
        color: "#00a63e",
        href: `${baseRoute}/agents`,
      },
      {
        title: "Warehouse Assets",
        value: Number(data?.warehouse_assets || 0).toLocaleString(),
        icon: <Warehouse size={20} />,
        bg: "#f3e8ff",
        color: "#9810fa",
        href: `${baseRoute}/warehouses`,
      },
      {
        title: "Office Inventory",
        value: Number(data?.office_inventory || 0).toLocaleString(),
        icon: <Building  size={20} />,
        bg: "#e0e7ff",
        color: "#4f39f6",
        href: `${baseRoute}/officeInventory`,
      },
      {
        title: "Agent Inventory",
        value: Number(data?.agent_inventory || 0).toLocaleString(),
        icon: <UserCheck  size={20} />,
        bg: "#cbfbf1",
        color: "#009689",
        href: `${baseRoute}/agentInventory`,
      },
    ];
  }, [
    data?.total_brokerages,
    data?.total_agents,
    data?.warehouse_assets,
    data?.office_inventory,
    data?.agent_inventory,
    baseRoute,
  ]);

  return (
<div className="row g-3 mb-4">
  {cards.map((card, idx) => (
    <div
      key={idx}
      className="col-12 col-sm col-md col-lg d-flex"
      style={{ minWidth: "200px" }} // optional to maintain decent card width
    >
      <div
        role="link"
        tabIndex={0}
        onClick={() => navigate(card.href)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            navigate(card.href);
          }
        }}
        className="card shadow-border-1 box-shadow-datatables bg-white w-100 h-100 text-decoration-none text-reset dashboard-summary-card-link"
        style={{
          borderRadius: "12px",
          border: "1px solid #E5E7EB",
          cursor: "pointer",
        }}
      >
        <div className="card-body d-flex justify-content-between align-items-center">
          <div>
            <h6 className="font-medium text-gray-600 text-xs" style={{ fontSize: "0.9rem" }}>
              {card.title}
            </h6>
            <h4 className="fw-bold mb-0 text-dark">{card.value}</h4>
          </div>

          <div
            className="d-flex align-items-center justify-content-center rounded-4"
            style={{
              backgroundColor: card.bg,
              color: card.color,
              width: "42px",
              height: "42px",
            }}
          >
            {card.icon}
          </div>
        </div>
      </div>
      <style>{`
        .card:hover {
          box-shadow: 0 3px 12px rgba(0,0,0,0.06) !important;
          transform: translateY(-1px);
          transition: 0.2s ease;
        }

        .dashboard-summary-card-link:hover {
          box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08) !important;
          transform: translateY(-1px);
          transition: 0.2s ease;
        }
        .text-gray-600 {
          color: #4a5565;
        }
          .text-xs {
          font-size: 0.75rem;
        }
      `}</style>
    </div>
  ))}
</div>


  );
};

export default TopSummaryCards;
